import React from "react";
import { MathOperatorButtonType } from "../mathOperatorTypes";

const Button = ({ className, value, onClick }: MathOperatorButtonType) => {

  let buttonClass = className === "bigButton" ?
    'tw-text-center tw-text-ink tw-text-lg tw-font-semibold tw-font-["Noto Sans"] tw-leading-relaxed tw-border-solid tw-col-span-2 tw-w-[100%] tw-h-11 tw-border tw-rounded-sm tw-p-2 tw-gap-2 tw-font-bold tw-cursor-pointer tw-bg-surface tw-border-edge hover:tw-bg-surface-hover':
    'tw-text-center tw-text-ink tw-text-lg tw-font-semibold tw-font-["Noto Sans"] tw-leading-relaxed tw-border-solid tw-w-[100%] tw-h-11 tw-rounded-sm tw-border tw-p-2 tw-gap-2 tw-font-bold tw-cursor-pointer tw-bg-surface tw-border-edge hover:tw-bg-surface-hover'
  return (
    <button data-testid="mathoperatorbutton-index-button-1" className={buttonClass} onClick={onClick}
      >
      {value}
    </button>
  );
};

export default Button;